<template>
    <b-modal id="facility_contract" ref="facility_contract" hide-footer size="xl"
             @hidden="$emit('close')"
             :title="setTitle">
        <b-row>
            <b-colxx md="12">
                Facility: <strong>{{ this.contract.data.attributes.facility }}</strong>
            </b-colxx>
            <b-colxx md="12">
                Notes: <strong>{{ this.contract.data.attributes.notes }}</strong>
            </b-colxx>
            <b-colxx md="12">
                Created by: <strong>{{ contract.data.attributes.created_by }}</strong>
            </b-colxx>
        </b-row>

        <div class="mt-4 mb-n4">
            <FilesList :files="attachments" @delete="deleteFile"/>

            <FileDelete v-if="file" :file="file" :base-url="base_url" @updated="$emit('file-deleted')"/>
        </div>
    </b-modal>
</template>

<script>
    import FilesList from "../../../../../components/Listing/FilesList";
    import FileDelete from "../../../../../components/Modal/FileDelete";
    export default {
        name: "FacilityContractModal",
        components: {FileDelete, FilesList},
        props: [
            'contract', 'attachments'
        ],

        data() {
            return {
                base_url: '/api/hms/locations/facilities/' + this.$route.params.facility_id + '/contracts/' + this.contract.contract_id + '/attachments',
                file: null,
            }
        },

        computed: {
            setTitle() {
                return `From: ${this.contract.data.attributes.from}, To: ${this.contract.data.attributes.to}`;
            }
        },

        methods: {
            deleteFile(file) {
                this.file = file;

                setTimeout(() => {
                    this.$bvModal.show('file_delete');
                }, 1);
            },
            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
